interface Country {
  callingCode: number;
  en: string;
}

const countries: { [code: string]: Country } = {
  US: { en: 'United States', callingCode: 1 },
  GB: { en: 'United Kingdom', callingCode: 44 },
  CA: { en: 'Canada', callingCode: 1 },
  AF: { en: 'Afghanistan', callingCode: 93 },
  AX: { en: 'Åland Islands', callingCode: 358 },
  AL: { en: 'Albania', callingCode: 355 },
  DZ: { en: 'Algeria', callingCode: 213 },
  AS: { en: 'American Samoa', callingCode: 1 },
  AD: { en: 'Andorra', callingCode: 376 },
  AO: { en: 'Angola', callingCode: 244 },
  AI: { en: 'Anguilla', callingCode: 1 },
  AQ: { en: 'Antarctica', callingCode: 672 },
  AG: { en: 'Antigua and Barbuda', callingCode: 1 },
  AR: { en: 'Argentina', callingCode: 54 },
  AM: { en: 'Armenia', callingCode: 374 },
  AW: { en: 'Aruba', callingCode: 297 },
  AC: { en: 'Ascension Island', callingCode: 247 },
  AU: { en: 'Australia', callingCode: 61 },
  AT: { en: 'Austria', callingCode: 43 },
  AZ: { en: 'Azerbaijan', callingCode: 994 },
  BS: { en: 'Bahamas', callingCode: 1 },
  BH: { en: 'Bahrain', callingCode: 973 },
  BD: { en: 'Bangladesh', callingCode: 880 },
  BB: { en: 'Barbados', callingCode: 1 },
  BY: { en: 'Belarus', callingCode: 375 },
  BE: { en: 'Belgium', callingCode: 32 },
  BZ: { en: 'Belize', callingCode: 501 },
  BJ: { en: 'Benin', callingCode: 229 },
  BM: { en: 'Bermuda', callingCode: 1 },
  BT: { en: 'Bhutan', callingCode: 975 },
  BO: { en: 'Bolivia', callingCode: 591 },
  BQ: { en: 'Bonaire, Sint Eustatius and Saba', callingCode: 599 },
  BA: { en: 'Bosnia and Herzegovina', callingCode: 387 },
  BW: { en: 'Botswana', callingCode: 267 },
  BR: { en: 'Brazil', callingCode: 55 },
  IO: { en: 'British Indian Ocean Territory', callingCode: 246 },
  BN: { en: 'Brunei Darussalam', callingCode: 673 },
  BG: { en: 'Bulgaria', callingCode: 359 },
  BF: { en: 'Burkina Faso', callingCode: 226 },
  MM: { en: 'Burma', callingCode: 95 },
  BI: { en: 'Burundi', callingCode: 257 },
  KH: { en: 'Cambodia', callingCode: 855 },
  CM: { en: 'Cameroon', callingCode: 237 },
  CV: { en: 'Cape Verde', callingCode: 238 },
  KY: { en: 'Cayman Islands', callingCode: 1 },
  CF: { en: 'Central African Republic', callingCode: 236 },
  TD: { en: 'Chad', callingCode: 235 },
  CL: { en: 'Chile', callingCode: 56 },
  CN: { en: 'China', callingCode: 86 },
  CX: { en: 'Christmas Island', callingCode: 61 },
  CC: { en: 'Cocos Islands', callingCode: 61 },
  CO: { en: 'Colombia', callingCode: 57 },
  KM: { en: 'Comoros', callingCode: 269 },
  CG: { en: 'Congo, Republic of the', callingCode: 242 },
  CD: { en: 'Congo, Democratic Republic of the', callingCode: 243 },
  CK: { en: 'Cook Islands', callingCode: 682 },
  CR: { en: 'Costa Rica', callingCode: 506 },
  CI: { en: "Cote d'Ivoire", callingCode: 225 },
  HR: { en: 'Croatia', callingCode: 385 },
  CU: { en: 'Cuba', callingCode: 53 },
  CW: { en: 'Curaçao', callingCode: 599 },
  CY: { en: 'Cyprus', callingCode: 357 },
  CZ: { en: 'Czech Republic', callingCode: 420 },
  DK: { en: 'Denmark', callingCode: 45 },
  DJ: { en: 'Djibouti', callingCode: 253 },
  DM: { en: 'Dominica', callingCode: 1 },
  DO: { en: 'Dominican Republic', callingCode: 1 },
  EC: { en: 'Ecuador', callingCode: 593 },
  EG: { en: 'Egypt', callingCode: 20 },
  SV: { en: 'El Salvador', callingCode: 503 },
  GQ: { en: 'Equatorial Guinea', callingCode: 240 },
  ER: { en: 'Eritrea', callingCode: 291 },
  EE: { en: 'Estonia', callingCode: 372 },
  ET: { en: 'Ethiopia', callingCode: 251 },
  FK: { en: 'Falkland Islands', callingCode: 500 },
  FO: { en: 'Faroe Islands', callingCode: 298 },
  FM: { en: 'Federated States of Micronesia', callingCode: 691 },
  FJ: { en: 'Fiji', callingCode: 679 },
  FI: { en: 'Finland', callingCode: 358 },
  FR: { en: 'France', callingCode: 33 },
  GF: { en: 'French Guiana', callingCode: 594 },
  PF: { en: 'French Polynesia', callingCode: 689 },
  TF: { en: 'French Southern Territories', callingCode: 262 },
  GA: { en: 'Gabon', callingCode: 241 },
  GM: { en: 'Gambia', callingCode: 220 },
  GE: { en: 'Georgia', callingCode: 995 },
  DE: { en: 'Germany', callingCode: 49 },
  GH: { en: 'Ghana', callingCode: 233 },
  GI: { en: 'Gibraltar', callingCode: 350 },
  GR: { en: 'Greece', callingCode: 30 },
  GL: { en: 'Greenland', callingCode: 299 },
  GD: { en: 'Grenada', callingCode: 1 },
  GP: { en: 'Guadeloupe', callingCode: 590 },
  GU: { en: 'Guam', callingCode: 1 },
  GT: { en: 'Guatemala', callingCode: 502 },
  GG: { en: 'Guernsey', callingCode: 44 },
  GN: { en: 'Guinea', callingCode: 224 },
  GW: { en: 'Guinea-Bissau', callingCode: 245 },
  GY: { en: 'Guyana', callingCode: 592 },
  HT: { en: 'Haiti', callingCode: 509 },
  HM: { en: 'Heard Island & McDonald Islands', callingCode: 0 },
  VA: { en: 'Holy See', callingCode: 39 },
  HN: { en: 'Honduras', callingCode: 504 },
  HK: { en: 'Hong Kong S.A.R. China', callingCode: 852 },
  HU: { en: 'Hungary', callingCode: 36 },
  IS: { en: 'Iceland', callingCode: 354 },
  IN: { en: 'India', callingCode: 91 },
  ID: { en: 'Indonesia', callingCode: 62 },
  IR: { en: 'Iran', callingCode: 98 },
  IQ: { en: 'Iraq', callingCode: 964 },
  IE: { en: 'Ireland', callingCode: 353 },
  IM: { en: 'Isle of Man', callingCode: 44 },
  IL: { en: 'Israel', callingCode: 972 },
  IT: { en: 'Italy', callingCode: 39 },
  JM: { en: 'Jamaica', callingCode: 1 },
  JP: { en: 'Japan', callingCode: 81 },
  JE: { en: 'Jersey', callingCode: 44 },
  JO: { en: 'Jordan', callingCode: 962 },
  KZ: { en: 'Kazakhstan', callingCode: 7 },
  KE: { en: 'Kenya', callingCode: 254 },
  KI: { en: 'Kiribati', callingCode: 686 },
  XK: { en: 'Kosovo', callingCode: 383 },
  KW: { en: 'Kuwait', callingCode: 965 },
  KG: { en: 'Kyrgyzstan', callingCode: 996 },
  LA: { en: 'Laos', callingCode: 856 },
  LV: { en: 'Latvia', callingCode: 371 },
  LB: { en: 'Lebanon', callingCode: 961 },
  LS: { en: 'Lesotho', callingCode: 266 },
  LR: { en: 'Liberia', callingCode: 231 },
  LY: { en: 'Libya', callingCode: 218 },
  LI: { en: 'Liechtenstein', callingCode: 423 },
  LT: { en: 'Lithuania', callingCode: 370 },
  LU: { en: 'Luxembourg', callingCode: 352 },
  MO: { en: 'Macau S.A.R. China', callingCode: 853 },
  MK: { en: 'Macedonia', callingCode: 389 },
  MG: { en: 'Madagascar', callingCode: 261 },
  MW: { en: 'Malawi', callingCode: 265 },
  MY: { en: 'Malaysia', callingCode: 60 },
  MV: { en: 'Maldives', callingCode: 960 },
  ML: { en: 'Mali', callingCode: 223 },
  MT: { en: 'Malta', callingCode: 356 },
  MH: { en: 'Marshall Islands', callingCode: 692 },
  MQ: { en: 'Martinique', callingCode: 596 },
  MR: { en: 'Mauritania', callingCode: 222 },
  MU: { en: 'Mauritius', callingCode: 230 },
  YT: { en: 'Mayotte', callingCode: 262 },
  MX: { en: 'Mexico', callingCode: 52 },
  MD: { en: 'Moldova', callingCode: 373 },
  MC: { en: 'Monaco', callingCode: 377 },
  MN: { en: 'Mongolia', callingCode: 976 },
  ME: { en: 'Montenegro', callingCode: 382 },
  MS: { en: 'Montserrat', callingCode: 1 },
  MA: { en: 'Morocco', callingCode: 212 },
  MZ: { en: 'Mozambique', callingCode: 258 },
  NA: { en: 'Namibia', callingCode: 264 },
  NR: { en: 'Nauru', callingCode: 674 },
  NP: { en: 'Nepal', callingCode: 977 },
  NL: { en: 'Netherlands', callingCode: 31 },
  NC: { en: 'New Caledonia', callingCode: 687 },
  NZ: { en: 'New Zealand', callingCode: 64 },
  NI: { en: 'Nicaragua', callingCode: 505 },
  NE: { en: 'Niger', callingCode: 227 },
  NG: { en: 'Nigeria', callingCode: 234 },
  NU: { en: 'Niue', callingCode: 683 },
  NF: { en: 'Norfolk Island', callingCode: 672 },
  KP: { en: 'North Korea', callingCode: 850 },
  MP: { en: 'Northern Mariana Islands', callingCode: 1 },
  NO: { en: 'Norway', callingCode: 47 },
  OM: { en: 'Oman', callingCode: 968 },
  PK: { en: 'Pakistan', callingCode: 92 },
  PW: { en: 'Palau', callingCode: 680 },
  PS: { en: 'Palestine', callingCode: 970 },
  PA: { en: 'Panama', callingCode: 507 },
  PG: { en: 'Papua New Guinea', callingCode: 675 },
  PY: { en: 'Paraguay', callingCode: 595 },
  PE: { en: 'Peru', callingCode: 51 },
  PH: { en: 'Philippines', callingCode: 63 },
  PN: { en: 'Pitcairn Islands', callingCode: 64 },
  PL: { en: 'Poland', callingCode: 48 },
  PT: { en: 'Portugal', callingCode: 351 },
  PR: { en: 'Puerto Rico', callingCode: 1 },
  QA: { en: 'Qatar', callingCode: 974 },
  RE: { en: 'Réunion', callingCode: 262 },
  RO: { en: 'Romania', callingCode: 40 },
  RU: { en: 'Russia', callingCode: 7 },
  RW: { en: 'Rwanda', callingCode: 250 },
  WS: { en: 'Samoa', callingCode: 685 },
  SM: { en: 'San Marino', callingCode: 378 },
  ST: { en: 'Sao Tome and Principe', callingCode: 239 },
  SA: { en: 'Saudi Arabia', callingCode: 966 },
  SN: { en: 'Senegal', callingCode: 221 },
  RS: { en: 'Serbia', callingCode: 381 },
  SC: { en: 'Seychelles', callingCode: 248 },
  SL: { en: 'Sierra Leone', callingCode: 232 },
  SG: { en: 'Singapore', callingCode: 65 },
  SX: { en: 'Sint Maarten', callingCode: 1 },
  SK: { en: 'Slovakia', callingCode: 421 },
  SI: { en: 'Slovenia', callingCode: 386 },
  SB: { en: 'Solomon Islands', callingCode: 677 },
  SO: { en: 'Somalia', callingCode: 252 },
  ZA: { en: 'South Africa', callingCode: 27 },
  KR: { en: 'South Korea', callingCode: 82 },
  SS: { en: 'South Sudan', callingCode: 211 },
  ES: { en: 'Spain', callingCode: 34 },
  LK: { en: 'Sri Lanka', callingCode: 94 },
  BL: { en: 'St. Barthélemy', callingCode: 590 },
  SH: { en: 'St. Helena', callingCode: 290 },
  KN: { en: 'St. Kitts and Nevis', callingCode: 1 },
  LC: { en: 'St. Lucia', callingCode: 1 },
  MF: { en: 'St. Martin', callingCode: 590 },
  PM: { en: 'St. Pierre and Miquelon', callingCode: 508 },
  VC: { en: 'St. Vincent and the Grenadines', callingCode: 1 },
  SD: { en: 'Sudan', callingCode: 249 },
  SR: { en: 'Suriname', callingCode: 597 },
  SJ: { en: 'Svalbard and Jan Mayen', callingCode: 47 },
  SZ: { en: 'Swaziland', callingCode: 268 },
  SE: { en: 'Sweden', callingCode: 46 },
  CH: { en: 'Switzerland', callingCode: 41 },
  SY: { en: 'Syria', callingCode: 963 },
  TW: { en: 'Taiwan', callingCode: 886 },
  TJ: { en: 'Tajikistan', callingCode: 992 },
  TZ: { en: 'Tanzania', callingCode: 255 },
  TH: { en: 'Thailand', callingCode: 66 },
  TL: { en: 'Timor-Leste', callingCode: 670 },
  TG: { en: 'Togo', callingCode: 228 },
  TK: { en: 'Tokelau', callingCode: 690 },
  TO: { en: 'Tonga', callingCode: 676 },
  TT: { en: 'Trinidad and Tobago', callingCode: 1 },
  TN: { en: 'Tunisia', callingCode: 216 },
  TR: { en: 'Turkey', callingCode: 90 },
  TM: { en: 'Turkmenistan', callingCode: 993 },
  TC: { en: 'Turks and Caicos Islands', callingCode: 1 },
  TV: { en: 'Tuvalu', callingCode: 688 },
  UG: { en: 'Uganda', callingCode: 256 },
  UA: { en: 'Ukraine', callingCode: 380 },
  AE: { en: 'United Arab Emirates', callingCode: 971 },
  UY: { en: 'Uruguay', callingCode: 598 },
  UZ: { en: 'Uzbekistan', callingCode: 998 },
  VU: { en: 'Vanuatu', callingCode: 678 },
  VE: { en: 'Venezuela', callingCode: 58 },
  VN: { en: 'Vietnam', callingCode: 84 },
  WF: { en: 'Wallis and Futuna', callingCode: 681 },
  EH: { en: 'Western Sahara', callingCode: 212 },
  YE: { en: 'Yemen', callingCode: 967 },
  ZM: { en: 'Zambia', callingCode: 260 },
  ZW: { en: 'Zimbabwe', callingCode: 263 },
};

// Get the list of country codes
export const countryCodes: string[] = Object.keys(countries);

// Get the country name by code
export const getCountryName = (code: string): string | null =>
  countries[code] ? countries[code].en : null;

// Get the country calling code by code
export const getCountryCallingCode = (code: string): number | null =>
  countries[code] ? countries[code].callingCode : null;
